import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import WhyChoose from "./sections/WhyChoose";
import Process from "./sections/Process";
import FinalCTA from "./sections/FinalCTA";
import Areas from "./sections/Areas";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <WhyChoose />
      <Process />
      <FinalCTA />
      <Areas />
      <Footer />
    </div>;
}